import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, take, switchMap, takeUntil } from 'rxjs/operators';

import {
  ClinicalAssessmentTypes,
  getClinicalAssessmentDisplayTitle
} from '@sondermind/utilities/models-assessments-monolith';
import { IAssessmentAnalyticsDisplayData, IAssessmentForAnalytics } from '@sondermind/utilities/models-assessments';
import { ClientAssessmentTypeResolver } from '@sondermind/data-access/assessments-monolith';
import { ClientDetailPageService } from '@sondermind/features/provider-facing/client-detail';

@Component({
  selector: 'member-client-detail-assessment-type',
  templateUrl: './client-detail-assessment-type.component.html',
  styleUrls: ['./client-detail-assessment-type.component.scss'],
  standalone: false
})
export class ClientDetailAssessmentTypePage implements OnInit, OnDestroy {
  constructor(
    private activatedRoute: ActivatedRoute,
    private clientDetailPageService: ClientDetailPageService,
    private assessmentTypeService: ClientAssessmentTypeResolver
  ) { }

  clinicalAssessmentTypes = ClinicalAssessmentTypes;

  assessmentType: ClinicalAssessmentTypes;
  displayTitle: string;

  data: IAssessmentAnalyticsDisplayData;

  private destroyed$ = new Subject<void>();

  ngOnInit(): void {
    this.assessmentType = this.activatedRoute.snapshot.paramMap.get('type') as ClinicalAssessmentTypes;
    this.displayTitle = getClinicalAssessmentDisplayTitle(this.assessmentType);

    this.clientDetailPageService.patient.pipe(
      filter((p) => p !== null),
      take(1),
      switchMap((p) => this.assessmentTypeService.getAssessmentAnalytics$(
        this.assessmentType,
        p.personaClientId,
        p.patientPlatformUuid
      )),
      takeUntil(this.destroyed$)
    ).subscribe((data) => {
      this.data = { ...data, assessments: this.sortAssessmentsByMostRecentAction(data.assessments) };
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  /**
 * Sort assessments by most recent action date (completed or sent date)
 */
  sortAssessmentsByMostRecentAction(assessments: IAssessmentForAnalytics[]): IAssessmentForAnalytics[] {
    return assessments.sort((a, b) => {
      const aMaxDate = a.completedAt ? a.completedAt : a.clinicallyRelevantAt;
      const bMaxDate = b.completedAt ? b.completedAt : b.clinicallyRelevantAt;

      return bMaxDate.getTime() - aMaxDate.getTime();
    });
  }
}
